import { get } from './API'
import * as constants from '@/mixins/constants'

export const placeAutocomplete = (params, config) => {
  let uri = constants.API.rest_api.place.autocomplete_v4

  if (params && params.mode && params.mode === constants.API_PLACE_SOURCE.GOOGLE) {
    uri = constants.API.rest_api.place.google_autocomplete
  }

  return get(uri, params, {
    token_required_header: true,
    baseURL: process.env.VUE_APP_REST_GW_MAP_API,
    ...config
  })
}

export const placeGeocodeReverse = (params, config) => {
  return get(constants.API.rest_api.place.geo_reverse, params, {
    token_required_header: true,
    baseURL: process.env.VUE_APP_REST_GW_MAP_API,
    ...config
  })
}

export const placeDetails = (params, config) => {
  config.headers = {
    ...config.headers,
    apikey: process.env.VUE_APP_REST_EP_API_KEY
  }

  const uri = constants.API.rest_api.place.details

  return get(uri, params, {
    token_required_header: true,
    baseURL: process.env.VUE_APP_REST_GW_MAP_API,
    ...config
  })
}
